import React, { FC, forwardRef, ReactNode, useMemo } from 'react';
import { BottomNavigation, BottomNavigationAction, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ChatIconOutlined from '@mui/icons-material/ChatOutlined';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import Paper from '@mui/material/Paper';
import { useSubscriberPaths } from '@subflow-frontend/routes/paths';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useDeviceType } from '@subflow-frontend/utils/useragent/useDeviceData';

interface ICustomLinkProps {
  href: string;
  children?: ReactNode;
}
const CustomLink: FC<ICustomLinkProps> = forwardRef<any, ICustomLinkProps>(
  ({ children, href, ...rest }, ref) => {
    return (
      <NextLink href={href}>
        <Link ref={ref} underline="none" {...rest}>
          {children}
        </Link>
      </NextLink>
    );
  }
);

interface ISubscriberBottomNavigationProps {
  children?: ReactNode;
}
export const SubscriberBottomNavigation: React.FC<
  ISubscriberBottomNavigationProps
> = () => {
  const { subscriberPaths } = useSubscriberPaths();
  const { asPath } = useRouter();
  const deviceType = useDeviceType();

  const activeTab = useMemo(() => {
    const config = {};
    config[subscriberPaths.dashboard + '/'] = 'home';
    config[subscriberPaths.chat + '/'] = 'chat';
    config[subscriberPaths.content.root + '/'] = 'content';
    return config[asPath];
  }, [
    asPath,
    subscriberPaths.chat,
    subscriberPaths.content.root,
    subscriberPaths.dashboard,
  ]);

  if (deviceType === 'desktop') {
    return null;
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: 'none', sm: 'block' },
      }}
      elevation={3}
    >
      <BottomNavigation showLabels value={activeTab}>
        <BottomNavigationAction
          value={'home'}
          LinkComponent={CustomLink}
          href={subscriberPaths.dashboard}
          label={'Home'}
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          value={'chat'}
          LinkComponent={CustomLink}
          href={subscriberPaths.chat}
          label="Chat"
          icon={<ChatIconOutlined />}
        />
        <BottomNavigationAction
          value={'content'}
          LinkComponent={CustomLink}
          href={subscriberPaths.content.root}
          label="Content"
          icon={<CollectionsOutlinedIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};
